import React, { useEffect, Fragment } from 'react'


import FileViewer from 'react-file-viewer';
import { RouteComponentProps } from 'react-router-dom';

export default class extends React.Component<RouteComponentProps> {
  state = { id: 0 }
  async componentDidMount() {
    let params = this.props.match.params as any
    let id: number = params.id || 0;
    if (id === 0) return;
    this.setState({ id })
  }


  render() {
    if (this.state.id === 0) {
      return ''
    }
    return (
      <Fragment>
        <FileViewer
          fileType='pdf'// 文件类型
          filePath={`/images/paddingBill/${this.state.id}.pdf`} // 文件地址   
        />
      </Fragment>
    )
  }

}



// WEBPACK FOOTER //
// ./src/page/interface/voucher/PreviewVoucher.tsx